/** useNow + nowOrFixed — single source of truth for "now" across both surfaces. */

import { useState, useEffect } from "react";

const REFRESH_INTERVAL_MS = 60_000;

/**
 * Returns the current wall-clock Date, or a fixed date when provided.
 * Use in fixture getters and tests to inject a deterministic "now"
 * without coupling to a global store.
 */
export function nowOrFixed(asOf?: Date): Date {
  return asOf ?? new Date();
}

/**
 * React hook returning a live wall-clock Date that refreshes every 60 s.
 * Replaces the demo-date override pattern — both surfaces get real time.
 *
 * Usage: `const now = useNow();` then pass `now` to formatEta, greeting, etc.
 */
export function useNow(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => { setNow(new Date()); }, REFRESH_INTERVAL_MS);
    return () => { clearInterval(id); };
  }, []);

  return now;
}
